export const isCpfValid = (suid: string): boolean => {
  if (
    suid === "00000000000" ||
    suid === "11111111111" ||
    suid === "22222222222" ||
    suid === "33333333333" ||
    suid === "44444444444" ||
    suid === "55555555555" ||
    suid === "66666666666" ||
    suid === "77777777777" ||
    suid === "88888888888" ||
    suid === "99999999999"
  )
    return false;

  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(suid.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(suid.charAt(9))) return false;
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(suid.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(suid.charAt(10))) return false;
  return true;
};

export const isCnpjValid = (suid: string): boolean => {
  if (
    suid === "00000000000000" ||
    suid === "11111111111111" ||
    suid === "22222222222222" ||
    suid === "33333333333333" ||
    suid === "44444444444444" ||
    suid === "55555555555555" ||
    suid === "66666666666666" ||
    suid === "77777777777777" ||
    suid === "88888888888888" ||
    suid === "99999999999999"
  )
    return false;

  let size = suid.length - 2;
  let numbers = suid.substring(0, size);
  let digits = suid.substring(size);
  let sum = 0;
  let pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) return false;

  size = size + 1;
  numbers = suid.substring(0, size);
  sum = 0;
  pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(1))) return false;

  return true;
};

export const isCMC7Valid = (cmc7: string) => {
  const part1 = cmc7.substring(0, 7);
  const part2 = cmc7.substring(8, 18);
  const part3 = cmc7.substring(19, 29);
  const digitC1 = Number.parseInt(cmc7.substring(18, 19));
  const digitC2 = Number.parseInt(cmc7.substring(7, 8));
  const digitC3 = Number.parseInt(cmc7.substring(29, 30));
  if (
    mod10(part1) !== digitC1 ||
    mod10(part2) !== digitC2 ||
    mod10(part3) !== digitC3
  )
    return false;
  return true;
};

const mod10 = (value: string) => {
  let dv = 0;
  let digits = value.split("").reverse();
  let evenIndexDigits = Array.from(
    { length: digits.length },
    (_, index) => index
  )
    .filter((it) => it % 2 === 0)
    .map((it) => Number.parseInt(digits[it]) * 2);
  let sumEvenIdexDigits = sumNumbers(evenIndexDigits);
  let oddIndexDigits = Array.from(
    { length: digits.length },
    (_, index) => index
  )
    .filter((it) => it % 2 !== 0)
    .map((it) => Number.parseInt(digits[it]));
  let sumOddIdexDigits = sumNumbers(oddIndexDigits);

  let mod = (sumEvenIdexDigits + sumOddIdexDigits) % 10;
  if (mod !== 0) dv = 10 - mod;
  return dv;
};

const sumNumbers = (values: number[]) => {
  let total = 0;
  total += values
    .filter((it) => it < 10)
    .map((it) => it)
    .reduce((partialSum, a) => partialSum + a, 0);
  total += values
    .filter((it) => it >= 10)
    .map((it) => it)
    .reduce((partialSum, a) => partialSum + sumDigits(a), 0);
  return total;
};

const sumDigits = (no: number): number => {
  return no === 0 ? 0 : (no % 10) + sumDigits(Math.trunc(no / 10));
};
